<template>
  <div class="rounded-lg bg-dark-modal">
    <div class="border-bottom border-secondary font-weight-bold h5 p-3">
      Gabarito
    </div>
    <div class="p-2 pb-4">
      <v-container
        v-for="(module,key) in challengeModules"
        :key="key"
        fluid
        class="mb-3"
      >
        <v-row>
          <v-col class="p-1 mt-3">
            <div
              v-if="module.block_id"
              class="small"
            >
              {{ module.block.trail.acronym }} | {{ module.block.name }} | {{ module.module_name }}
            </div>
            <div
              v-else
              class="small"
            >
              {{ module.subject_acronym }} | {{ module.module_name }}
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-4 justify-content-start">
          <v-col
            v-for="(question) in module.questions"
            :key="question.key"
            class="col-auto p-1"
          >
            <v-tooltip
              v-if="question.invalidated"
              top
            >
              <template #activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <MarkerComponentItem
                    :question="question"
                    :challenge="challenge"
                    :is-active="activeTab == question.key"
                    @click="$emit('input', question.key)"
                  />
                </div>
              </template>
              <span>Essa questão foi anulada.</span>
            </v-tooltip>
            <MarkerComponentItem
              v-else
              :question="question"
              :challenge="challenge"
              :is-active="activeTab == question.key"
              @click="$emit('input',question.key)"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import MarkerComponentItem from "@/common/components/challenge/MarkerComponentItem"
import { mapGetters } from "vuex";
export default {
  name: 'MarkerComponent',
  components:{
    MarkerComponentItem,
  },
  props: {
    challenge: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['challengeModules']),
  }
}
</script>

